export const codeLanguageMap = {
  en: "English",
  "hi-in": "हिन्दी", // Hindi
}

export const codeLanguageAbbreviationMap = {
  en: "Eng",
  "hi-in": "हिन्दी", // Hindi
}
